enum Frequency {
    Monthly = 1,
    Quarterly = 3,
    SemiAnnually = 6,
    Annually = 12
}

export default Frequency;